export * from './useAnalyticsLoadEvent';
export * from './useAnalyticsPingEvent';
export * from './useAnalyticsViewEvent';
export * from './useAnalyticsClickEvent';
export * from './useAnalyticsConversionEvent';

// Useful for view and click events which have a URL field
export const getPageUrl = () => {
    // returns the page URL without the query string or the hash
    // see: https://stackoverflow.com/a/75884674/2992570
    const { origin, pathname } = new URL(window.location.href);
    return `${origin}${pathname}`;
};
